import React from 'react';

interface DownloadButtonsProps {
  className?: string;
  variant?: 'default' | 'centered';
}

const DownloadButtons: React.FC<DownloadButtonsProps> = ({ 
  className = '', 
  variant = 'default' 
}) => {
  const containerClass = variant === 'centered' 
    ? 'flex flex-col sm:flex-row justify-center gap-6' 
    : 'flex flex-col sm:flex-row justify-center lg:justify-start gap-6';

  return (
    <div className={`${containerClass} ${className}`}>
      <a 
        href="https://forms.gle/JymF2pmvTt8Ln6m4A" 
        target="_blank" 
        rel="noopener noreferrer"
        className="hover:opacity-90 transition-opacity"
        onClick={() => {
          // Analytics tracking for App Store download
          if (typeof window !== 'undefined' && (window as any).gtag) {
            (window as any).gtag('event', 'download_app_store', {
              event_category: 'engagement',
              event_label: 'app_store_download'
            });
          }
        }}
      >
        <img 
          src="/appstore.svg" 
          alt="Download on the App Store" 
          width="204" 
          height="59" 
          className="h-14 w-auto"
        />
      </a>
      <a 
        href="https://play.google.com/store/apps/details?id=com.bitesizr.android" 
        target="_blank" 
        rel="noopener noreferrer"
        className="hover:opacity-90 transition-opacity"
        onClick={() => {
          // Analytics tracking for Google Play download
          if (typeof window !== 'undefined' && (window as any).gtag) {
            (window as any).gtag('event', 'download_google_play', {
              event_category: 'engagement',
              event_label: 'google_play_download'
            });
          }
        }}
      >
        <img 
          src="/googleplay.svg" 
          alt="Get it on Google Play" 
          width="204" 
          height="59" 
          className="h-14 w-auto"
        />
      </a>
    </div>
  );
};

export default DownloadButtons;